//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { formatTime } from '../../../../components/helpers.js'
import Table from '../../../../components/Table/Table.vue'

export default {
  components: {
    Table
  },
  props: {
    brigadesQueue: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data: function () {
    return {
      pagination: {
        rowsPerPage: 25,
        page: 1
      },
      columns: [
        {
          name: 'brigadeGUIName',
          label: 'Название бригады',
          align: 'left',
          field: 'brigadeGUIName',
          sortable: true
        },
        {
          name: 'assignmentTime',
          label: 'Время назначения',
          align: 'left',
          field: 'assignmentTime',
          format: formatTime,
          sortable: true
        },
        {
          name: 'fromTime',
          label: 'Время принятия',
          align: 'left',
          field: 'fromTime',
          format: formatTime,
          sortable: true
        },
        {
          name: 'toTime',
          label: 'Время сдачи',
          align: 'left',
          field: 'toTime',
          format: formatTime,
          sortable: true
        },
        {
          name: 'canceled',
          label: 'Отменено',
          align: 'left',
          field: 'canceled',
          format: value => value ? 'Да' : 'Нет',
          sortable: true
        },
        // {
        //   name: 'time',
        //   label: 'Время внесения бригады в заявку',
        //   align: 'left',
        //   field: 'time',
        //   sortable: true,
        //   format: formatTime
        // },
        {
          name: 'fio',
          label: 'Автор изменения (внесения бригады в заявку)',
          align: 'left',
          field: 'fio',
          sortable: true
        }
      ]
    }
  },
  methods: {
    getTrClass: function (row) {
      if (row.canceled) {
        return 'd-tr--grey'
      }
    }
  }
}

